import $ from 'jquery'
import Backbone from 'backbone'
import template from './current-user-activity.hbs'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import DisplayHeader from 'scoreboard/components/display-header'
import SortableTableView from 'scoreboard/components/sortable-table-view'
import currentUserTable from './current-user-table.hbs'
import config from 'scoreboard/components/config'

const DEFAULT_SORT = {
	sortField: 'lastActiveTime',
	ascending: false
}

var CurrentUserActivity = Backbone.View.extend({

	className: 'admin current-user-activity table-hack display-layout scroll-layout-xy',

	/**
	 *
	 * @param {array} options.users User details for each user
	 */
	initialize: function (options) {
		this.options = options || {}
		this.users = this.options.users
		this.reloadInterval = setInterval(function() {
			$.get('api/admin/users/active').then(function(users) {
				this._buildTable(users)
				this.sortableTable.applySort(users)
			}.bind(this))
		}.bind(this), 30000 /* 30 seconds per Issue #11251 */)
	},

	render: function () {
		this.$el.empty().append(new DisplayHeader({
			heading: i18n.get('admin.currentUserActivity.userActivity'),
			mobileGearHidden: true
		}).render().el, template())

		this._buildTable(this.users)

		this.sortableTable = new SortableTableView({
			el: this.$('table'),
			defaultSortField: 'lastActiveTime',
			data: this.users,
			fields: ['databaseAlias', 'displayName', 'loginTime', 'lastActiveTime', 'remoteHost', 'sessionId']
		})
		this.listenTo(this.sortableTable, 'sorted', users => this._buildTable(users))

		return this
	},

	_buildTable: function(users) {
		this.$('.total-users')
			.html(`(${i18n.get('admin.currentUserActivity.totalUsers', users.length)})`)
		this.$('.panel-content').empty()
		if (!_.isEmpty(users)) {
			this.$('.panel-content').append(currentUserTable({ users, config }))
		}
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.sortableTable], 'remove')
		clearInterval(this.reloadInterval)
	}
})

export default CurrentUserActivity

CurrentUserActivity.__filename__ = 'admin/current-user-activity.js'
